import { makeStyles } from "tss-react/mui";

export const useChipLinkStyles = makeStyles({
  name: "ChipLink",
})(() => ({
  wrapper: {
    transition: "transform .15s ease-in-out",
    "&:hover": {
      transform: "scale(1.1)",
    },
    "&, & *": {
      cursor: "pointer",
    },
  },
}));
